import * as ProductsActions from './products.actions';
import * as fromProducts from './products.reducers';
import * as ProductsSelectors from './products.selectors';
import { Injectable } from '@angular/core';
import { Store, select, Action } from '@ngrx/store';

@Injectable()
export class ProductsFacade {
  constructor(private store: Store<fromProducts.State>) {}

  productDetails$ = this.store.pipe(select(ProductsSelectors.selectProductDetails));
  isLoading$ = this.store.pipe(select(ProductsSelectors.isLoading));

  dispatch(action: Action) {
    this.store.dispatch(action);
  }
  getProduct(productId: number) {
    this.dispatch(ProductsActions.getProduct({productId}));
  }
}
